import { createBinaryClient, createTypedClient } from "@hub/api/services";
import { WorkQueueService } from "@hub/proto/workqueue/v1/workqueue_pb";
import { ProjectionService } from "@hub/proto/projections/v1/projections_pb";
import { SearchService } from "@hub/proto/search/v1/search_pb";
import { SchemaService } from "@hub/proto/schema/v1/schema_pb";
import { EvalReviewService } from "@hub/proto/evalreview/v1/evalreview_pb";
import { BlobStoreService } from "@hub/proto/blobstore/v1/blobs_pb";

export { createTypedClient };

export * from "@hub/proto/workqueue/v1/workqueue_pb";
export * from "@hub/proto/projections/v1/projections_pb";
export * from "@hub/proto/search/v1/search_pb";

export const workQueueService = createTypedClient(WorkQueueService);
export const projectionService = createTypedClient(ProjectionService);
export const searchService = createTypedClient(SearchService);
// Eval review vertical (HUB-512): the reviewer workbench's blind compare +
// batch queue resolve against this service.
export const evalReviewService = createTypedClient(EvalReviewService);
// Config-driven view/form definitions (HUB-408) — the record primitive resolves
// its field layout from the ACTIVE `view` definition served here.
export const schemaService = createTypedClient(SchemaService);
// Source-document retrieval for the eval reviewer (HUB-509). The anesthesia
// record a case was coded from is stored as a blob at ingest and fetched by id
// — see src/audit/sources/caseDocument.ts for why the bytes are streamed here
// rather than served from a URL the browser could cache.
// BINARY wire format, unlike every other client here: these messages carry the
// document itself in a `bytes` field, and Connect's JSON default would
// base64 it — a third more bytes plus a JSON.parse and base64 decode for each
// 64KB chunk, on the main thread, between the reviewer clicking a case and
// seeing the record.
export const blobStoreService = createBinaryClient(BlobStoreService);
